import type { Load } from "~/shared/schemas/loads-schema.ts";

/**
 * Default ordering applied to the loads data before it reaches the grid:
 * Pickup Date desc, then Delivery Date desc, then PO Number desc. Applied via
 * a pre-sort (rather than the grid's `sort` prop) so the column headers do
 * not show a sort indicator on initial load. A user clicking a column header
 * replaces this with their chosen sort via the grid's `onSortChange`.
 *
 * Rows with a missing date sort to the bottom of the descending order.
 */
export const compareDefaultLoadOrder = (a: Load, b: Load): number => {
	const pickupA = a.loadDateValue?.getTime() ?? Number.NEGATIVE_INFINITY;
	const pickupB = b.loadDateValue?.getTime() ?? Number.NEGATIVE_INFINITY;
	if (pickupA !== pickupB) return pickupB - pickupA;

	const deliveryA = a.deliveryDateValue?.getTime() ?? Number.NEGATIVE_INFINITY;
	const deliveryB = b.deliveryDateValue?.getTime() ?? Number.NEGATIVE_INFINITY;
	if (deliveryA !== deliveryB) return deliveryB - deliveryA;

	// poNumber is numeric in the Load schema; compare numerically (desc) so
	// e.g. 100 sorts before 99. Missing values sort to the bottom.
	const poA = a.poNumber ?? Number.NEGATIVE_INFINITY;
	const poB = b.poNumber ?? Number.NEGATIVE_INFINITY;
	return poB - poA;
};
